module.exports = __webpack_public_path__ + "media/assets/svgs/share-a8545a054d259037998d2a1b30286dbc.svg";